<template>
  <Transition
    @before-enter="onBeforeEnter"
    @enter="onEnter"
    @after-enter="onAfterEnter"
    @before-leave="onBeforeLeave"
    @leave="onLeave"
    @after-leave="onAfterLeave"
  >
    <slot />
  </Transition>
</template>

<script>
// Based on ElementUI's collapse-transition
/* eslint-disable no-param-reassign */
import { addClass, removeClass } from '@/utils/dom';

export default {
  props: {
    direction: {
      type: String,
      default: 'vertical',
      validator(value) {
        return ['vertical', 'horizontal'].includes(value);
      },
    },
    isDisabled: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    onBeforeEnter(el) {
      if (this.isDisabled) return;

      addClass(el, 'collapse-transition');
      if (!el.dataset) el.dataset = {};

      if (this.direction === 'vertical') {
        el.dataset.oldPaddingTop = el.style.paddingTop;
        el.dataset.oldPaddingBottom = el.style.paddingBottom;

        el.style.height = '0';
        el.style.paddingTop = 0;
        el.style.paddingBottom = 0;

        return;
      }

      el.dataset.oldPaddingLeft = el.style.paddingLeft;
      el.dataset.oldPaddingRight = el.style.paddingRight;

      el.style.width = '0';
      el.style.paddingLeft = 0;
      el.style.paddingRight = 0;
    },
    onEnter(el) {
      if (this.isDisabled) return;

      el.dataset.oldOverflow = el.style.overflow;

      // if (el.scrollHeight !== 0 && el.scrollWidth !== 0) {
      //   el.style.width = `${el.scrollWidth}px`;
      //   el.style.height = `${el.scrollHeight}px`;
      //   el.style.paddingTop = el.dataset.oldPaddingTop;
      //   el.style.paddingBottom = el.dataset.oldPaddingBottom;
      // } else {
      //   el.style.width = '';
      //   el.style.height = '';
      //   el.style.paddingTop = el.dataset.oldPaddingTop;
      //   el.style.paddingBottom = el.dataset.oldPaddingBottom;
      // }
      if (this.direction === 'vertical') {
        if (el.scrollHeight !== 0) {
          el.style.height = `${el.scrollHeight}px`;
          el.style.paddingTop = el.dataset.oldPaddingTop;
          el.style.paddingBottom = el.dataset.oldPaddingBottom;
        } else {
          el.style.height = '';
          el.style.paddingTop = el.dataset.oldPaddingTop;
          el.style.paddingBottom = el.dataset.oldPaddingBottom;
        }
      } else if (el.scrollWidth !== 0) {
        el.style.width = `${el.scrollWidth}px`;
        el.style.paddingLeft = el.dataset.oldPaddingLeft;
        el.style.paddingRight = el.dataset.oldPaddingRight;
      } else {
        el.style.width = '';
        el.style.paddingLeft = el.dataset.oldPaddingLeft;
        el.style.paddingRight = el.dataset.oldPaddingRight;
      }

      el.style.overflow = 'hidden';
    },
    onAfterEnter(el) {
      if (this.isDisabled) return;

      // for safari: remove class then reset height is necessary
      removeClass(el, 'collapse-transition');

      if (this.direction === 'vertical') {
        el.style.height = '';
      } else {
        el.style.width = '';
      }

      el.style.overflow = el.dataset.oldOverflow;
      this.$emit('after-enter');
    },
    onBeforeLeave(el) {
      if (this.isDisabled) return;

      if (!el.dataset) el.dataset = {};

      el.dataset.oldOverflow = el.style.overflow;
      el.style.overflow = 'hidden';

      if (this.direction === 'vertical') {
        el.dataset.oldPaddingTop = el.style.paddingTop;
        el.dataset.oldPaddingBottom = el.style.paddingBottom;

        el.style.height = `${el.scrollHeight}px`;

        return;
      }

      el.dataset.oldPaddingLeft = el.style.paddingLeft;
      el.dataset.oldPaddingRight = el.style.paddingRight;

      el.style.width = `${el.scrollWidth}px`;
    },
    onLeave(el) {
      if (this.isDisabled) return;

      if (this.direction === 'vertical' && el.scrollHeight !== 0) {
        addClass(el, 'collapse-transition');

        el.style.height = 0;
        el.style.paddingTop = 0;
        el.style.paddingBottom = 0;
      } else if (el.scrollWidth !== 0) {
        addClass(el, 'collapse-transition');

        el.style.width = 0;
        el.style.paddingLeft = 0;
        el.style.paddingRight = 0;
      }
    },
    onAfterLeave(el) {
      if (this.isDisabled) return;

      removeClass(el, 'collapse-transition');

      el.style.overflow = el.dataset.oldOverflow;

      if (this.direction === 'vertical') {
        el.style.height = '';
        el.style.paddingTop = el.dataset.oldPaddingTop;
        el.style.paddingBottom = el.dataset.oldPaddingBottom;

        return;
      }

      el.style.width = '';
      el.style.paddingLeft = el.dataset.oldPaddingLeft;
      el.style.paddingRight = el.dataset.oldPaddingRight;
      this.$emit('after-leave');
    },
  },
};
</script>

<style scoped>
.collapse-transition {
  transition: 250ms width easeInOutQuart,
  250ms height easeInOutQuart,
  250ms padding-top easeInOutQuart,
  250ms padding-bottom easeInOutQuart;
}
</style>
